<script>
  import CustomIcon from '../../components/CustomIcon.svelte';
import Video from '../../components/Video.svelte';
  import {clickOutside} from '../../utils/outsideClick';

  export let source;
  export let poster;
  export let onClose = () => {};
</script>

<!-- This example requires Tailwind CSS v2.0+ -->
<div
  class="fixed z-100 inset-0 overflow-y-auto"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
>
  <div
    class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
  >
    <!--
        Background overlay, show/hide based on modal state.
  
        Entering: "ease-out duration-300"
          From: "opacity-0"
          To: "opacity-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100"
          To: "opacity-0"
      -->
    <div
      class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      aria-hidden="true"
    />

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span
      class="hidden sm:inline-block sm:align-middle sm:h-screen"
      aria-hidden="true">&#8203;</span
    >

    <!--
        Modal panel, show/hide based on modal state.
  
        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
    <div
      class="inline-block cursor-pointer align-bottom bg-white p-2 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-full max-w-2xl sm:w-full "
      use:clickOutside on:click_outside={onClose}
    >
      <div class="hidden sm:block absolute top-3 right-7 z-40 ">
        <div
          type="button"
          class="text-white hover:text-gray-500 border-transparent cursor-pointer"
          on:click={onClose}
        >
          <span class="sr-only">Close</span>
          <!-- Heroicon name: outline/x -->
          
            <CustomIcon width="20" height="20" name="outline_x"/>
        </div>
      </div>
      <Video {source} {poster} />
    </div>
  </div>
</div>
